import { render, staticRenderFns } from "./EffectTypeEdit.vue?vue&type=template&id=0120ac42&scoped=true&"
import script from "./EffectTypeEdit.vue?vue&type=script&lang=js&"
export * from "./EffectTypeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0120ac42",
  null
  
)

export default component.exports